var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"bg-white border-l border-gray-300 flex-00a w-1/4-screen"},[_c('portal-target',{attrs:{"name":"ActionBar"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }